import Asset from "./pages/Asset";
import Assets from "./pages/Assets";
import SeriesBuilder from "./pages/SeriesBuilder";

const assetRoutes = [
  {
    path: "assets",
    element: <Assets />,
  },
  {
    path: "assets/unlinked-episodes",
    element: <SeriesBuilder />,
  },
  {
    path: "assets/:id",
    element: <Asset />,
  },
];

export default assetRoutes;
